export const types = {
  CREATE_LOGBOOK_S3_URL: "CREATE_LOGBOOK_S3_URL",
  CREATE_LOGBOOK_S3_URL_SUCCESS: "CREATE_LOGBOOK_S3_URL_SUCCESS",
  GET_LOGBOOK_DATA: "GET_LOGBOOK_DATA",
  GET_LOGBOOK_DATA_SUCCESS: "GET_LOGBOOK_DATA_SUCCESS",
  GET_LOGBOOK_DATA_EXCEL_S3: "GET_LOGBOOK_DATA_EXCEL_S3",
  GET_LOGBOOK_DATA_EXCEL_S3_SUCCESS: "GET_LOGBOOK_DATA_EXCEL_S3_SUCCESS",
};
